module.exports = __webpack_public_path__ + "img/52800.d20fd85d.jpg";